import {
  getWalletConnectConnector,
  type RainbowKitWalletConnectParameters,
  type Wallet,
} from '@rainbow-me/rainbowkit'
import { rabbyWallet } from '@rainbow-me/rainbowkit/wallets'

type RabbyMobileWalletOptions = {
  projectId: string
  walletConnectParameters?: RainbowKitWalletConnectParameters
}

const getRabbyMobileUri = (uri: string) =>
  `rabby://walletconnect?uri=${encodeURIComponent(uri)}`

export const rabbyMobileWallet = ({
  projectId,
  walletConnectParameters,
}: RabbyMobileWalletOptions): Wallet => {
  const injectedRabbyWallet = rabbyWallet()
  const shouldUseWalletConnect = !injectedRabbyWallet.installed

  return {
    ...injectedRabbyWallet,
    installed: shouldUseWalletConnect
      ? undefined
      : injectedRabbyWallet.installed,
    downloadUrls: {
      ...injectedRabbyWallet.downloadUrls,
      android:
        'https://play.google.com/store/apps/details?id=com.debank.rabbymobile',
      ios: 'https://apps.apple.com/us/app/rabby-wallet-crypto-evm/id6474381673',
      mobile: 'https://rabby.io/?platform=mobile',
      qrCode: 'https://rabby.io/?platform=mobile',
    },
    mobile: shouldUseWalletConnect
      ? {
          getUri: getRabbyMobileUri,
        }
      : undefined,
    qrCode: shouldUseWalletConnect
      ? {
          getUri: (uri) => uri,
        }
      : undefined,
    createConnector: shouldUseWalletConnect
      ? getWalletConnectConnector({
          projectId,
          walletConnectParameters,
        })
      : injectedRabbyWallet.createConnector,
  }
}
